module.exports = __webpack_public_path__ + "static/media/WorkflowsCloseDrawerIcon.a3dad532.svg";